export default "__VITE_ASSET__C05u3et0__"